function supports() {
  let obs = supportsIntersectionObserver();
  let f = supportsFilters();
  return obs && f;
}

export default supports;

function supportsIntersectionObserver() {
  return (
    'IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype
  );
}

function supportsFilters() {
  let filterEl = document.createElement('div');
  filterEl.style.cssText = 'filter:blur(2px)';
  return (
    filterEl.style.length != 0 &&
    (document.documentMode === undefined || document.documentMode > 9)
  );
}
